import { useEffect, useRef } from "react";

export const Cursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const target = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      }
    };
    const onOver = (e) => {
      const isInteractive = e.target.closest("a, button, [data-cursor='hover'], input, textarea, select");
      if (ringRef.current) {
        if (isInteractive) {
          ringRef.current.style.width = "58px";
          ringRef.current.style.height = "58px";
          ringRef.current.style.borderColor = "#13535A";
          ringRef.current.style.borderWidth = "2px";
        } else {
          ringRef.current.style.width = "34px";
          ringRef.current.style.height = "34px";
          ringRef.current.style.borderColor = "#13535A";
          ringRef.current.style.borderWidth = "1.5px";
        }
      }
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);

    let raf;
    const tick = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.18;
      pos.current.y += (target.current.y - pos.current.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
};
